import CryptoJS from 'crypto-js';
import { getLoanCurrentUtm, PARTNER_CURRENT_UTM_SUCCESS } from '../../store/actions/customer-actions';
import { loanApprovedInCreditPolicy } from '../../store/actions/loan-actions';
import { tagGoogleAnalyticsEvent } from '../../store/actions/application-actions';
import reduxStore from '../../store/store';
import {
  DISBURSEMENT_COMPLETED,
  UNDERWRITING_STARTED,
  APPLICATION_CONTRACT_READY,
} from '../enumerator/enum-loan-state';
import { DECLINED } from '../enumerator/enum-loan-phase';

import { isRecurring } from './loan-helper';

let loading = false;

function manageEvents(loan) {
  if (loan?.id) {
    addUtmsOnStorage(loan);
  }

  if (
    loan?.application?.personal?.emailAddress &&
    !isRecurring(loan) &&
    !window?.location?.pathname.includes('/cliente')
  ) {
    setEventOnDataLayer('getEmail', loan, {
      userEmail: CryptoJS.SHA256(loan.application.personal.emailAddress).toString(),
    });
  }

  if (JSON.parse(sessionStorage.getItem('ON_EBS_SUCCESS'))) {
    setEventOnEbsSuccess();
  }

  if (loan) {
    setEventsOnApplication();
  }

  sendDisbusementGAEvent(loan);
  sendCpApprovedGAEvent(loan);
  sendDeclinedGAEvent(loan);
  sendContractReadyGAEvent(loan);
}

function sendDisbusementGAEvent(loan) {
  const eventName = 'disbursement_completed';
  const loanValue = loan?.conditions?.principal?.toString() || '';

  if (
    loan?.id &&
    loan?.state?.id >= DISBURSEMENT_COMPLETED &&
    !isRecurring(loan) &&
    !loan?.application?.additionalInformation?.hasOwnProperty(eventName)
  ) {
    reduxStore.dispatch(tagGoogleAnalyticsEvent(eventName)).then(() => {
      // Send event from datalayer to use in GA4, including the loan amount
      setEventOnDataLayer(eventName, null, { value: loanValue, currency: 'BRL' });
    });
  }
}

function sendCpApprovedGAEvent(loan) {
  const eventName = 'cp_approved';

  if (
    loan?.id &&
    loan?.state?.id >= UNDERWRITING_STARTED &&
    !isRecurring(loan) &&
    !loan?.application?.additionalInformation?.hasOwnProperty(eventName)
  ) {
    reduxStore.dispatch(loanApprovedInCreditPolicy()).then((response) => {
      if (response?.payload == true) {
        reduxStore.dispatch(tagGoogleAnalyticsEvent(eventName)).then(() => {
          // Send event from datalayer to use in GA4
          setEventOnDataLayer('getConversion');
        });
      }
    });
  }
}

function sendDeclinedGAEvent(loan) {
  const eventName = 'funil_negado';

  if (
    loan?.id &&
    loan?.state?.phase?.id == DECLINED &&
    !isRecurring(loan) &&
    !loan?.application?.additionalInformation?.hasOwnProperty(eventName)
  ) {
    reduxStore.dispatch(tagGoogleAnalyticsEvent(eventName)).then(() => {
      // Send event from datalayer to use in GA4
      setEventOnDataLayer(eventName);
    });
  }
}

function sendContractReadyGAEvent(loan) {
  const eventName = 'funil_contract_ready';

  if (
    loan?.id &&
    loan?.state?.id == APPLICATION_CONTRACT_READY &&
    !isRecurring(loan) &&
    !loan?.application?.additionalInformation?.hasOwnProperty(eventName)
  ) {
    reduxStore.dispatch(tagGoogleAnalyticsEvent(eventName)).then(() => {
      // Send event from datalayer to use in GA4
      setEventOnDataLayer(eventName);
    });
  }
}

/**
 * Set the event on dataLayer.
 */
function setEventOnDataLayer(event, loan, additionalFields) {
  if (!loan) {
    if (!window.dataLayer.some((item) => item.event === event)) {
      window.dataLayer?.push({
        event,
        ...additionalFields,
      });
    }
    return;
  }

  if (loan?.application?.personal?.id) {
    const personId = loan.application.personal.id;
    const loanId = loan.id;
    const loanState = loan.state.id;
    const loanPhase = loan.state.phase.id;
    const recurrency = loan?.labels2?.recurrency;
    const source = loan?.application?.utmSource;

    if (!window.dataLayer.some((item) => item.event === event)) {
      window.dataLayer?.push({
        event,
        personId,
        loanId,
        loanState,
        loanPhase,
        recurrency,
        source,
        value: additionalFields?.value || 0,
        currency: additionalFields?.currency || 'BRL',
        ...additionalFields,
      });
    }
  }
}

function addUtmsOnStorage() {
  if (loading) return;

  // is loading.
  loading = true;

  const savedSource = sessionStorage.getItem('savedUtmSource');

  // Get in the params if not exists in the sessionStorage.
  if (!savedSource) {
    // If the source not exists in the sessionStorage or url Param, get in the Api.
    reduxStore.dispatch(getLoanCurrentUtm()).then((response) => {
      loading = false;
      if (response.type == PARTNER_CURRENT_UTM_SUCCESS) {
        // If return some utm.
        if (response.payload?.source) {
          sessionStorage.setItem('savedUtmSource', response.payload?.source.toString());
        }
      }
    });
  }
}

/**
 * Set event on datalayer on ebs success.
 */
function setEventOnEbsSuccess() {
  const ON_EBS_SUCCESS = JSON.parse(sessionStorage.getItem('ON_EBS_SUCCESS'));
  if (ON_EBS_SUCCESS && !window.dataLayer.some((item) => item.event === ON_EBS_SUCCESS)) {
    window.dataLayer?.push({
      event: 'ebs_success',
    });
  }
}

/**
 * Set events when session storage changes
 */
window.addEventListener('dataLayerApplicationEvent', manageEvents);

/**
 * Set all funnel screen change events
 */
function setEventsOnApplication() {
  const DATALAYER_APPLICATION_EVENT = sessionStorage.getItem('dataLayerApplicationEvent');

  if (DATALAYER_APPLICATION_EVENT && !window.dataLayer.some((item) => item.event === DATALAYER_APPLICATION_EVENT)) {
    window.dataLayer?.push({
      event: DATALAYER_APPLICATION_EVENT,
    });
  }
}

export { manageEvents, setEventOnDataLayer };
